import { useQuery, useQueryClient } from '@tanstack/react-query'
import { Media } from '~/shared/api'

export const useImgLoad = (url?: string) => {
  const queryKey = ['image', url]
  const queryClient = useQueryClient()
  const cachedObjectURL = queryClient.getQueryData<string>(queryKey)

  const fetchMedia = async () => {
    if (!url) return ''

    const blob = await Media.getMedia(url)

    return URL.createObjectURL(blob)
  }

  const { data: imageUrl, isLoading } = useQuery<string>(
    queryKey,
    () => fetchMedia(),
    {
      enabled: !cachedObjectURL,
      retry: false,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    },
  )

  return { isLoading, imageUrl }
}
